export function setDocumentStyles(data) {
  const root = document.documentElement;

  let primary = data?.primary_color ? data.primary_color : "#F25926";
  let secondary = data?.color ? data?.color : "#f57e56";

  /* main styling */
  root?.style.setProperty("--primary-button-color", primary);
  root?.style.setProperty("--secondary-button-color", secondary);

  /* text-color */
  root?.style.setProperty("--rs-listbox-option-hover-text", "#fff");
  root?.style.setProperty("--rs-listbox-option-selected-text", "#fff");
  root?.style.setProperty("--rs-picker-value", primary);
  root?.style.setProperty("--rs-btn-link-text", primary);
  root?.style.setProperty("--rs-btn-link-hover-text", secondary);
  root?.style.setProperty("--rs-btn-ghost-text", primary);
  root?.style.setProperty("--rs-btn-ghost-hover-text", primary);
  root?.style.setProperty("--rs-btn-ghost-active-text", primary);
  root?.style.setProperty("--rs-btn-subtle-text", primary);
  root?.style.setProperty("--rs-btn-subtle-hover-text", "white");
  root?.style.setProperty("--rs-tooltip-text", "white");

  /* background-colors */
  root?.style.setProperty("--rs-listbox-option-hover-bg", secondary);
  root?.style.setProperty("--rs-listbox-option-selected-bg", secondary);
  root?.style.setProperty("--rs-bg-active", primary);
  root?.style.setProperty("--rs-calendar-range-bg", primary);
  root?.style.setProperty("--rs-btn-primary-bg", primary);
  root?.style.setProperty("--rs-calendar-cell-selected-hover-bg", secondary);
  root?.style.setProperty("--rs-btn-primary-hover-bg", secondary);
  root?.style.setProperty("--rs-slider-progress", primary);
  root?.style.setProperty("--rs-slider-thumb-border", primary);
  //root?.style.setProperty("--rs-btn-subtle-hover-bg", secondary);
  root?.style.setProperty("--rs-tooltip-bg", secondary);

  /* border/focus */
  root?.style.setProperty("--rs-input-focus-border", secondary);
  root?.style.setProperty("--rs-color-focus-ring", "transparent");
  root?.style.setProperty("--rs-btn-ghost-border", primary);
  root?.style.setProperty("--rs-btn-ghost-hover-border", primary);
  root?.style.setProperty("--rs-btn-ghost-active-border", primary);
  root?.style.setProperty("--rs-checkbox-checked-bg", primary);

  root?.style.setProperty("--rs-slider-bar", "gray");

  /* nezasa */
  root?.style.setProperty("--nz-brand-primary", secondary);
  /* favicon */
  if (
    data?.length > 0 &&
    data?.logo &&
    data?.logo[0] &&
    data?.logo[0]?.file_url !== undefined
  ) {
    const favicon =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    favicon.rel = "icon";
    favicon.type = "image/*";
    favicon.href = data && data.logo && data.logo[0] && data.logo[0].file_url;
    document.head.appendChild(favicon);
  }
}
